export default "__VITE_ASSET__BgwEaKAq__"